import React, { FC, ReactNode, useMemo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

import { Tooltip } from 'src/shared/components';

interface Props extends Omit<IconButtonProps, 'size'> {
  tooltip?: ReactNode;
  size?: number;
  loading?: boolean;
  showTooltipIcon?: boolean;
}

export const IconButton: FC<Props> = ({
  children,
  size = 24,
  color = 'primary',
  tooltip,
  disabled,
  loading = false,
  onClick,
  sx,
  showTooltipIcon,
  ...props
}) => {
  const IconButton = useMemo(
    () => (
      <StyledIconButton {...props} disabled={disabled} onClick={onClick} color={color} sx={sx}>
        {loading ? <CircularProgress size={size} sx={{ color: (theme) => theme.palette.text.disabled }} /> : children}
      </StyledIconButton>
    ),
    [loading, onClick, disabled, color, size, props],
  );

  return (
    <>
      {tooltip ? (
        <Tooltip title={tooltip} showIcon={showTooltipIcon}>
          <span>{IconButton}</span>
        </Tooltip>
      ) : (
        IconButton
      )}
    </>
  );
};

const StyledIconButton = styled(MuiIconButton)(({ theme, disabled }) => ({
  borderRadius: '8px',

  ...(theme.palette.mode === 'light'
    ? {
        backgroundColor: theme.palette.secondary.main,
      }
    : {
        border: `1px solid ${!disabled ? theme.palette.secondary.main : theme.palette.action.disabled}`,
      }),
}));
